import React, { useCallback } from 'react';

import { doRequest } from '@r1-frontend/do-request';
import { ResponseDto } from '@r1-frontend/api-domru/dadata/suggest/dto/ResponseDto';
import suggestFio from '@r1-frontend/api-domru/dadata/suggest/fio';

import { IPersonFormProps, PersonForm as PersonFormComponent } from '@r1-frontend/ui-react/organisms/Forms/PersonForm';

type TProps = Omit<IPersonFormProps, 'onLoadSuggestions'>;

export const PersonForm = ({
    fio,
    phone,
    onChangeFio,
    onChangePhone,
    isNeedToBlockInvalidFio = false,
    actionButtonProps,
}: TProps): JSX.Element => {
    const onLoadSuggestions = useCallback(async(value) => {
        const resp = await doRequest.dadataProxy<ResponseDto>(
            suggestFio(value),
        );

        return resp.isSuccess
            ? resp.payload?.suggestions.map(suggestion => suggestion.value)
            : [];
    }, []);

    return (
        <PersonFormComponent
            onLoadSuggestions={onLoadSuggestions}
            fio={fio}
            phone={phone}
            onChangeFio={onChangeFio}
            onChangePhone={onChangePhone}
            isNeedToBlockInvalidFio={isNeedToBlockInvalidFio}
            actionButtonProps={actionButtonProps}
        />
    );
};
